// Auto-generated - do not edit manually
import React from "react";
import { BaseIcon } from "../../BaseIcon";
import type { BaseIconProps } from "../../types";

const solidContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_text-align-center--solid"><path id="Union" d="M21 21H3V19H21V21ZM17.0078 17H7.00781V15H17.0078V17ZM21 13H3V11H21V13ZM17.0078 9H7.00781V7H17.0078V9ZM21 5H3V3H21V5Z" style="fill: currentColor"/></g></svg>`;
const lineContent = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"><g id="icon_text-align-center--line"><path id="Union" d="M21.002 21H3.00195V19H21.002V21ZM17.0098 17H7.00977V15H17.0098V17ZM21.002 13H3.00195V11H21.002V13ZM17.0098 9H7.00977V7H17.0098V9ZM21.002 5H3.00195V3H21.002V5Z" style="fill: currentColor"/></g></svg>`;

export const TextAlignCenter: React.FC<BaseIconProps> = (props) => (
  <BaseIcon {...props} solidContent={solidContent} lineContent={lineContent} />
);
